const FullscreenLoader = () => (
	<div className="fixed inset-0 flex items-center justify-center bg-bgBase-300">
		<div className="animate-spin h-10 w-10 border-4 border-primary-500 border-t-transparent rounded-full" />
	</div>
);

export default FullscreenLoader;
